import React from 'react';
import { Card, Typography } from 'antd';
import { useTranslation } from 'react-i18next';

const { Paragraph } = Typography;

const UsefulContacts = () => {
  const { t } = useTranslation();
  
  return (
    <Card title={t('contacts.title')}>
      <Paragraph>
        <strong>{t('contacts.helpIntro')}</strong>
      </Paragraph>
      <Paragraph>
        {t('contacts.messageUs')}
      </Paragraph>
      <Paragraph>
        {t('contacts.alwaysAvailable')}
      </Paragraph>
      
      <Paragraph>
        <strong>{t('contacts.emergencyTitle')}</strong>
      </Paragraph>
      <Paragraph>
        {t('contacts.emergencyIntro')}
      </Paragraph>
      <ul>
        <li><strong>112</strong> – <strong>{t('contacts.emergencyNumbers.general')}</strong></li>
        <li><strong>118</strong> – <strong>{t('contacts.emergencyNumbers.medical')}</strong></li>
        <li><strong>115</strong> – <strong>{t('contacts.emergencyNumbers.fire')}</strong></li>
        <li><strong>113</strong> – <strong>{t('contacts.emergencyNumbers.police')}</strong></li>
        <li><strong>116</strong> – <strong>{t('contacts.emergencyNumbers.roadside')}</strong></li>
      </ul>
      <Paragraph>
        <strong>{t('contacts.tip')}</strong>
      </Paragraph>
    </Card>
  );
};

export { UsefulContacts };
